import React from 'react';
import Slider from "react-slick"; // Import the react-slick Slider component
import img1 from '../../../src/assets/images/454A9051.jpg';
import img2 from '../../../src/assets/images/454A9096.jpg';
import img3 from '../../../src/assets/images/454A9115.jpg';
import img4 from '../../../src/assets/images/454A9127.jpg';
import img5 from '../../../src/assets/images/454A9170.jpg';
import img6 from '../../../src/assets/images/454A9209.jpg';
import img7 from '../../../src/assets/images/454A9251.jpg';
import img8 from '../../../src/assets/images/454A9280.jpg';
import img9 from '../../../src/assets/images/454A9286.jpg';
import './AboutUs.styled.css';

const AboutUs = () => {
  const carouselImages = [
    { src: img1, alt: "Image 1" },
    { src: img2, alt: "Image 2" },
    { src: img3, alt: "Image 3" },
    { src: img4, alt: "Image 4" },
    { src: img5, alt: "Image 5" },
    { src: img6, alt: "Image 6" },
    { src: img7, alt: "Image 7" },
    { src: img8, alt: "Image 8" },
    { src: img9, alt: "Image 9" },
  ];

  const sliderSettings = {
    dots: true, // Enable navigation dots
    infinite: true, // Loop through slides infinitely
    speed: 500, // Animation speed in ms
    slidesToShow: 1, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval in ms
    arrows: true, // Show navigation arrows
  };

  return (
    <div className="bg-[#F5F5F5] p-8 font-serif" id="about-section">
      <div className="text-center mb-6 text-[#DC143C] text-xl">
        TRADITIONAL GREEK CHEESE
      </div>
      <div className="text-center mb-6 text-black text-3xl font-bold">
        Taste the Heritage of Greece with Our Feta Cheese
      </div>
      {/* Carousel Section */}
      <div className="flex justify-center mb-6">
        <div className="w-full max-w-[800px]">
          <Slider {...sliderSettings}>
            {carouselImages.map((image, index) => (
              <div key={index}>
                <img
                  src={image.src}
                  alt={image.alt}
                  className="max-w-full h-auto rounded"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {/* Description Section */}
      <div className="text-black text-lg max-w-[800px] mx-auto">
        At our company, we promise to deliver the authentic taste of Greece to your plate with every bite of our small crafted feta cheese.
        Made with love and care by expert artisans using traditional techniques, our cheese is a perfect blend of rich flavors and creamy textures
        that will transport your taste buds to the Mediterranean.
      </div>
    </div>
  );
};

export default AboutUs;
